import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ebc4a29"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:basis-1/3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold md:text-3xl" }, " যেকোন প্রয়োজনে কল করো "),
  /*#__PURE__*/_createElementVNode("h2", { class: "lg:mt-4" }, " কোর্স, ক্লাস, পড়াশোনা, প্রোমো কোড অথবা যেকোনো বিষয়ে জানতে হলে এখনই কল করো। ")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "flex max-w-[210px] items-center justify-center gap-2 rounded-lg border-[0.5px] border-blue-1 p-1 text-[#E11845] sm:px-4 sm:py-2.5"
}
const _hoisted_3 = { class: "text-lg font-semibold text-[#E11845] sm:text-xl" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "btn-3 flex h-9 w-full max-w-[210px] items-center justify-center font-medium md:h-10 md:text-base lg:h-12 xl:h-13 xl:text-lg"
}
const _hoisted_6 = { class: "text-lg font-semibold sm:text-xl" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-medium" }, " (সকাল ১০ টা থেকে রাত ১০টা) ", -1))

import {
  computed,
} from 'vue';
import {
  useRoute,
} from 'vue-router';
import PhoneCallLogo from '@/components/Icon/PhoneCallLogo.vue';
import {
  CONSTANTS,
} from '@/helpers';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInfo',
  setup(__props) {


const contactInfo = computed(() => useStore.app.viewConfig.landingPage.contactInfo);
const { contactNo } = useStore.backend.clientCompany;

const isPublicHome = computed(() => useRoute().name === CONSTANTS.ROUTE.home.title);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col justify-between gap-4 rounded-lg bg-dynamicInfoBg px-3 py-6 xs:px-7 sm:justify-start", isPublicHome.value ? 'box-shadow text-dynamicInfoText' : 'bg-white text-black'])
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(["mt-4 flex flex-col gap-4", { 'lg:mt-10': isPublicHome.value }])
    }, [
      (contactInfo.value.theme === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(PhoneCallLogo, { fillColor: "#E11845" }),
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("a", {
                href: `tel:${_unref(contactNo)}`
              }, _toDisplayString(_unref(contactNo)), 9, _hoisted_4)
            ])
          ]))
        : (contactInfo.value.theme === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(PhoneCallLogo, { fillColor: "#333333" }),
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("a", {
                  href: `tel:${_unref(contactNo)}`
                }, _toDisplayString(_unref(contactNo)), 9, _hoisted_7)
              ])
            ]))
          : _createCommentVNode("", true),
      _hoisted_8
    ], 2)
  ], 2))
}
}

})